export default "__VITE_ASSET__BAPGKOMY__"